import { render, staticRenderFns } from "./lazyblock_attention.vue?vue&type=template&id=2c4d309e&scoped=true"
import script from "./lazyblock_attention.vue?vue&type=script&lang=js"
export * from "./lazyblock_attention.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_attention.vue?vue&type=style&index=0&id=2c4d309e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4d309e",
  null
  
)

export default component.exports